export const SYSTEMS = {
  Flood: 1,
  RescAlert: 2,
  VMS: 3,
  USGS: 4,
} as const;

export const DEVICE_TYPES = {
  Stage: 1,
  ManualRoadClosure: 2,
  TechBridge_Siren_Giant_Voice: 3,
  TechBridge_Flashing_Light: 4,
  VMSCamera: 5,
  MonitoringStation: 6,
} as const;
